import React from 'react';

export const Footer = () => {
  return (
    <footer className="bg-body-tertiary py-3 mt-5" data-bs-theme="dark">
    <p className="text-center pt-3" style={{color: "#e2e8f0"}}>© 2023 newsy, Developed by Nishu Anand.</p>
  </footer>
  )
}
